import { render, staticRenderFns } from "./LapPengurangan.vue?vue&type=template&id=7aa4b490"
import script from "./LapPengurangan.vue?vue&type=script&lang=js"
export * from "./LapPengurangan.vue?vue&type=script&lang=js"
import style0 from "./LapPengurangan.vue?vue&type=style&index=0&id=7aa4b490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports